import { Spinner } from './feedback';
import { useState, type FormEvent } from 'react';
import qrcode from 'qrcode-generator';
import type { EnrollmentInput, EnrollmentOptions } from '@mcpanel/core';
import { RecoveryCodes } from './RecoveryCodes';
export { RecoveryCodes } from './RecoveryCodes';
import { AuthField } from './AuthFields';

export function AuthenticatorQr({ options }: { options: EnrollmentOptions }) {
  const qr = qrcode(0, 'M');
  qr.addData(options.uri);
  qr.make();
  return (
    <div className="stack">
      <p>認証アプリで QR コードを読み取ってください。</p>
      <img width="240" height="240" src={qr.createDataURL(5, 4)} alt="認証アプリ登録用 QR コード" />
      <p>
        手入力用の秘密鍵: <code style={{ overflowWrap: 'anywhere' }}>{options.secret}</code>
      </p>
    </div>
  );
}
export function EnrollmentForm({
  begin,
  finish,
  onDone,
  initialLogin = '',
  initialName = '',
}: {
  begin: (input: EnrollmentInput) => Promise<EnrollmentOptions>;
  finish: (code: string) => Promise<{ recoveryCodes: string[] }>;
  onDone: () => void;
  initialLogin?: string;
  initialName?: string;
}) {
  const [name, setName] = useState(initialName);
  const [login, setLogin] = useState(initialLogin);
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [options, setOptions] = useState<EnrollmentOptions>();
  const [codes, setCodes] = useState<string[]>();
  const [error, setError] = useState<string>();
  const [busy, setBusy] = useState(false);
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setError(undefined);
    setBusy(true);
    try {
      if (options) {
        setCodes((await finish(code)).recoveryCodes);
        setOptions(undefined);
        setCode('');
      } else {
        setOptions(await begin({ name, login, password }));
        setPassword('');
      }
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : String(caught));
      if (options) setOptions(undefined);
    } finally {
      setBusy(false);
    }
  };
  if (codes) return <RecoveryCodes codes={codes} login={login} onDone={onDone} />;
  return (
    <form className="stack" onSubmit={(e) => void submit(e)}>
      {error && <div className="alert danger">{error}</div>}
      {options ? (
        <>
          <AuthenticatorQr options={options} />
          <AuthField label="確認のワンタイムコード（6 桁）" value={code} onChange={setCode} code totpOnly />
        </>
      ) : (
        <>
          <AuthField label="表示名" value={name} onChange={setName} />
          <AuthField
            label="ログイン ID（SFTP 名と共通）"
            value={login}
            onChange={setLogin}
            login
            disabled={!!initialLogin}
          />
          <AuthField
            label="パスワード（12〜128 文字）"
            value={password}
            onChange={setPassword}
            password
            newPassword
            loginValue={login}
          />
          <p className="small muted">ログイン ID を含むパスワードは使えません。</p>
        </>
      )}
      <button className="btn primary" disabled={busy}>
        {busy && <Spinner />}
        {options ? 'コードを確認' : '認証アプリの登録へ'}
      </button>
    </form>
  );
}
